var shippingCalcWidgetController = {
    updateCountryStateListCometActionName: 'UPDATE_STATE_LIST_ACTION',

    divId: 'shippingCalcWidget',
    goButtonDivId: 'shippingCalcWidgetGoButtonDiv',
    quoteListDivId: 'shippingCalcWidgetQuoteListDiv',
    countryListName: 'SHIPPINGCOUNTRYLIST',
    ccountrylist: null,
    countryLabel: 'Ship To Country',
    countryDD: 'SHIPPINGCOUNTRYDD',
    ccountry: null,

    stateContainerId: 'shipToAddressContainerStateRow',
    cstatelist: null,
    stateLabel: 'Ship To Region / State',
    stateListName: 'COUNTRYSTATELIST',
    stateDD: 'SHIPPINGSTATEDD',
    cstate: null,

    zipLabel: 'Ship To Zip',
    zipEF: 'SHIPPINGZIPEF',
    zip: '',
    goButtonId: 'UPDATESHIPPINGQUOTESBT',
    initialized: false,
    cquotelist: null,
    chandler: null,
    spinner: tags.span(tags.img(SPINNERIMAGE), {cssClass: 'preloader'}),

    fetchCountries: function () {
        return new Promise(function (resolve, reject) {
            var siteId;
            if (window.configureCommonGlobals) {
                siteId = configureCommonGlobals.siteId;
            } else if (window.stockGlobals) {
                siteId = stockGlobals.siteId;
            }
            $.ajax({
                url: '/api/site-service/sites/' + siteId + '/countries',
                method: 'GET',
                accept: 'application/json',
                success: function (countries) {
                    var shippingCountries = countries.filter(function (country) {
                        return country.shipTo === true;
                    });
                    resolve(shippingCountries);
                },
                error: function () {
                    console.error('Error fetching countries');
                    reject();
                }
            });
        });
    },
    fetchShippingDefaults: function () {
        return new Promise(function (resolve, reject) {
            $.ajax({
                url: '/rest/storefront/shippingQuotes/defaults',
                method: 'GET',
                accept: 'application/json',
                success: function (shippingDefaults) {
                    resolve(shippingDefaults);
                },
                error: function () {
                    console.error('Error fetching shipping quote defaults');
                    reject();
                }
            });
        });
    },
    initialize: function () {
        Promise.all([this.fetchCountries(), this.fetchShippingDefaults()]).then(function (data) {
            var countries = data[0];
            var defaults = data[1].content;
            shippingCalcWidgetController.ccountrylist = countries;
            var defaultCountry = countries.find(function (c) {
                return c.id === defaults.defaultCountryId;
            });
            shippingCalcWidgetController.setCountry(defaultCountry);
            shippingCalcWidgetController.setZip(defaults.defaultZipCode);

            if (defaults.showEstimateShippingOption === true) {
                shippingCalcWidgetController.display();
            }

            shippingCalcWidgetController.initialized = true;
        });
    },
    display: function () {
        var content = '';
        content += '<div class="shippingCalcInputs">\n';
        content += '<label class="countryText">' + this.countryLabel + '</label>';
        content += '<div class="countryDD">' + forms.dd(this.countryDD, this.ccountrylist, this.ccountry, {
            id: this.countryDD,
            showNullOption: false,
            onchange: 'shippingCalcWidgetController.onCountryDDChange()'
        }) + '</div>';
        content += '<div id="' + this.stateContainerId + '" class="c-region-holder">';
        content += '<label class="c-ship-estimate-label c-state">' + this.stateLabel + '</label>';
        content += '<div class="c-ship-estimate-field c-state-dd">' + forms.dd(this.stateDD, this.cstatelist, this.cstate, {
            id: this.stateDD,
            showNullOption: true,
            onchange: 'shippingCalcWidgetController.onStateDDChange()'
        }) + '</div>';
        content += '</div>';
        content += '<label class="zipText">' + this.zipLabel + '</label>';
        content += '<div class="zipEF">' + forms.ef(this.zipEF, this.zip, {
            id: this.zipEF,
            cssClass: '',
            onkeyup: 'shippingCalcWidgetController.onEFKeyUp(event)'
        }) + '</div>';
        content += tags.div(this.buildGoButtonContent(), {
            id: this.goButtonDivId,
            cssClass: 'getQuotesButton'
        });
        content += tags.div('<!-- dynamic -->', {
            id: 'shippingValidationMessagesDiv'
        });
        content += tags.div('', {
            id: this.quoteListDivId,
            cssClass: 'shipQuoteList'
        });
        content += '</div>';
        dynamic.setDivIdContent(this.divId, content);
    },
    setCountry: function (newCountry) {
        if (newCountry != null) {
            this.showGoButton();
            this.ccountry = newCountry;
            setFieldValue(this.countryDD, this.ccountry.id, document);
            this.updateStateList(newCountry);
        }
    },
    displayStateDD: function (ccountry) {
        var content = '';
        if (ccountry == null) {
            this.hideElement(this.stateContainerId);
        } else if (ccountry.regions) {
            var cstateslist = ccountry.regions;
            var cselectedstate = null;
            if (ccountry.id == this.defaultCountryId && this.defaultStateId != null) {
                cselectedstate = getStateWithId(cstateslist, this.defaultStateId);
            }
            content += forms.dd(this.stateDDName, cstateslist, cselectedstate, {
                nameProperty: 'name'
            });
            this.showElement(this.stateContainerId);
        } else {
            this.hideElement(this.stateContainerId);
        }
        dynamic.setDivIdContent(this.stateDD, content);
    },
    updateStateList: function (country) {
        var ccountry = country;
        if (!ccountry) {
            ccountry = this.getCountryWithId(getDropDownSelectedValue(this.countryDD, document));
        }
        if (ccountry != null) {
            this.cstatelist = ccountry.regions;
            this.displayStateDD(ccountry);
        }
        this.ccountry = ccountry;
    },

    setZip: function (newZip) {
        if (hasValue(newZip)) {
            this.showGoButton();
            this.zip = newZip;
            setFieldValue(this.zipEF, this.zip, document);
        }
    },
    onCountryDDChange: function () {
        this.ccountry = this.getCountryWithId(getDropDownSelectedValue(this.countryDD, document));
        shippingCalcWidgetController.showGoButton();
        shippingCalcWidgetController.updateStateList();
    },
    onStateDDChange: function () {
        this.cstate = this.getStateWithId(getDropDownSelectedValue(this.stateDD, document));
        shippingCalcWidgetController.showGoButton();
    },
    onEFKeyUp: function (event) {
        shippingCalcWidgetController.showGoButton();
        if (isEnterEvent(event)) {
            shippingCalcWidgetController.getQuotes();
        }
    },
    onQuoteChange: function () {
        if (shippingCalcWidgetController.initialized) {
            shippingCalcWidgetController.showGoButton();
        }
    },
    onLogin: function (ccountry, czip) {
        this.setCountry(ccountry);
        this.setZip(czip.value);
    },
    showGoButton: function () {
        if (getFormItem(this.goButtonId, document) == null) {
            dynamic.setDivIdContent(this.goButtonDivId, this.buildGoButtonContent());
        }
        dynamic.setDivIdContent(this.quoteListDivId, '');
    },
    buildGoButtonContent: function () {
        var content = '';
        content += forms.button('Get Shipping Quotes', {
            name: this.goButtonId,
            onclick: 'shippingCalcWidgetController.getQuotes()',
            cssClass: 'secondary'
        });
        return content;
    },
    hideGoButton: function () {
        dynamic.setDivIdContent(this.goButtonDivId, '');
    },
    showQuoteList: function () {
        dynamic.setDivIdContent(this.goButtonDivId, '');
        dynamic.setDivIdContent(this.quoteListDivId, this.buildQuoteListContent());
    },
    buildQuoteListContent: function () {
        var content = '';
        if (this.cquotelist != null && this.cquotelist.length > 0) {
            var clist = this.cquotelist;
            var table = new JDTable({
                cssClass: 'shippingCalcEstimates'
            });
            table.addRow([
                {
                    text: 'Service',
                    tag: 'th'
                },
                {
                    text: 'Estimate',
                    tag: 'th'
                }
            ]);
            for (var i = 0, ni = clist.length; i < ni; i++) {
                var rowId = clist[i].serviceName
                    .replace(/[^\w\s-]+|\s+/g, '-')
                    .replace(/^-+|-+(?=-|$)/g, '')
                    .toLowerCase();

                table.addRow(
                    [
                        {
                            text: clist[i].serviceName,
                            cssClass: 'shipServiceName'
                        },
                        {
                            text: strPrice(clist[i].price),
                            cssClass: 'shipServicePrice'
                        }
                    ],
                    {
                        id: rowId
                    }
                );
            }
            content += table.generate();
        }
        return content;
    },
    showValidationMessages: function () {
        var content = '';

        //
        // preserve any existing quote error messages
        if (typeof configureglobals != 'undefined') {
            var cquotedata = configureglobals.cquotedata;
            if (cquotedata != null) {
                var quoteValidation = new JobQuoteValidation(cquotedata.validation);
                content += quoteValidation.generateGlobalMessages();
            }
        }

        //
        content += this.validation.generateGlobalMessages();

        //
        dynamic.setDivIdContent('shippingValidationMessagesDiv', content);
    },
    getQuotes: function () {
        if (this.initialized) {
            var validator = new Validator();
            var container = $('#shippingCalcWidget');
            var validateItemOptions = {
                customParent: true,
                parent: container
            };
            var ccountry = this.getCountryWithId(getDropDownSelectedValue(this.countryDD, container));
            if (ccountry != null && ccountry.hasRegions) {
                validator.addItem(newValidateItem(this.stateDD, this.stateLabel, validateItemOptions));
            }
            if (ccountry != null && ccountry.hasPostalCodes) {
                validator.addItem(newValidateItem(this.zipEF, this.zipLabel, validateItemOptions));
            }
            if (validator.isValid()) {
                var that = this;

                var coffering = configureglobals.coffering;
                var cstockoffering = configureglobals.cstockoffering;
                var cquote = configureglobals.cquote;
                var countryId = getFormItemValue(this.countryDD, document);
                var stateId = getFormItemValue(this.stateDD, document);
                var zip = getFormItemValue(this.zipEF, document);

                var request = {
                    productIdWithPrefix: coffering ? configureCommonGlobals.idWithPrefix : stockGlobals.idWithPrefix,
                    countryId: +countryId,
                    stateId: +stateId,
                    zip: zip,
                    totalOunces: this.getTotalOunces(cquote),
                    itemsTotal: cquote.totalPrice
                };

                dynamic.setDivIdContent(this.quoteListDivId, this.spinner);
                this.doShippingQuoteRequest(request).then(function (response) {
                    dynamic.setDivIdContent(that.quoteListDivId, '');
                    var shippingServiceQuotes = response.content.shippingServiceQuotes;
                    if (shippingServiceQuotes) {
                        that.cquotelist = shippingServiceQuotes;
                    } else {
                        that.cquotelist = null;
                    }
                    that.showQuoteList();
                    that.validation = new ShippingQuoteValidation({
                        hasGlobalErrorMessages: response.content.globalErrorMessages.length > 0,
                        globalErrorMessages: response.content.globalErrorMessages.map(function (msg) {
                            return { value: msg };
                        }),
                        hasGlobalInfoMessages: response.content.globalInfoMessages.length > 0,
                        globalInfoMessages: response.content.globalInfoMessages.map(function (msg) {
                            return { value: msg };
                        })
                    });
                    that.showValidationMessages();
                });
            }
        }
    },
    getTotalOunces: function (cquote) {
        if (cquote.pjQuote) {
            return cquote.pjQuote.totalOunces; // Small Format
        }

        if (cquote.lpjQuote) {
            return cquote.lpjQuote.totalOunces; // Large Format
        }

        if (cquote.stockQuote) {
            return cquote.stockQuote.totalOunces; // Stock
        }
    },
    doShippingQuoteRequest: function (request) {
        return new Promise(function (resolve, reject) {
            $.ajax({
                url: '/rest/storefront/shippingQuotes',
                method: 'POST',
                accept: 'application/json',
                contentType: 'application/json',
                data: JSON.stringify(request),
                success: function (shippingQuote) {
                    resolve(shippingQuote);
                },
                error: function () {
                    console.error('Error generating shipping quotes');
                    reject();
                }
            });
        });
    },
    getCountryWithId: function (idString) {
        if (idString == null || idString == '') {
            return null;
        }
        var countries = this.ccountrylist;
        var id = toInt(idString);
        for (var i = 0, ni = countries == null ? 0 : countries.length; i < ni; i++) {
            var ccountry = countries[i];
            if (ccountry.id == id) {
                return ccountry;
            }
        }
        return null;
    },
    getStateWithId: function (idString) {
        if (idString == null || idString == '') {
            return null;
        }
        var states = this.cstatelist;
        var id = toInt(idString);
        for (var i = 0, ni = states == null ? 0 : states.length; i < ni; i++) {
            var state = states[i];
            if (state.id == id) {
                return state;
            }
        }
        return null;
    },
    showElement: function (elementId) {
        dynamic.removeClass(elementId, 'hideIt');
    },
    hideElement: function (elementId) {
        dynamic.addClass(elementId, 'hideIt');
    }
};
